import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import download from "downloadjs";
import RaisedButton from "material-ui/RaisedButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { MaskedTextField } from "vault-react-components";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { TextField, FlatButton } from "material-ui";
import { Card, CardTitle, CardMedia, CardText } from "material-ui/Card";
import FilterCard from "../../components/FilterCard/FilterCard";
import {
	actionDeleteAfiliado,
	actionChangeAfiliadoProps,
	actionGetAfiliadosList,
	actionProcessExcel,
	asyncCheckCuil
} from "../../actions/AfiliadoActions";
import { actionGenerateExcel } from "../../actions/GenerateExcelActions";
import {
	AFILIADOS_NEW,
	AFILIADOS_EDIT,
	INDEX
} from "../../config/RoutesConstants";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import Util, { SUCCESS, ERROR, WARNING } from "../../common/Util";
import AppMem from "../../common/AppMem";
import OptionsTableRowColumn from "../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import {
	PERSONA_IMPORTADO,
	PERSONA_VERIFICAR,
	PERSONA_VERIFICADO,
	AFILIADO_ACTIVO,
	AFILIADO_INACTIVO,
	ROL_ADMIN,
	ROL_EMPRESA,
	ROL_SUB_ADMIN,
	ROL_OPERADOR_RECAUDA
} from "../../common/Constants";
import Paginator from "../../components/Paginator/Paginator";
import { onKeyPressNumberOnly } from "../../common/validaciones";

let limitePagina = 10;

class AfiliadosIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			affiliateFile: null,
			showFilterCard: false,
			rol: this.props.rol,
			itemsList: []
		};
		this.handleDelete = this.handleDelete.bind(this);
		this.onCreateOrUpdate = this.onCreateOrUpdate.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.onTapConfirmDelete = this.onTapConfirmDelete.bind(this);
		this.asynValidate = this.asynValidate.bind(this);
		this.returnDownload = this.returnDownload.bind(this);
	}

	componentWillMount() {
		if (this.props.rol === ROL_EMPRESA) this.props.history.push(INDEX);
		if (this.props.rol === ROL_ADMIN)
			this.getAfiliados(this.props.page, limitePagina);
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.rol !== nextProps.rol && nextProps.rol === ROL_EMPRESA) {
			this.props.history.push(INDEX);
		}
	}
	componentWillUnmount() {
		this.props.actionChangeAfiliadoProps({
			afiliadosList: [],
			searchtext: "",
			total: 0
		});
	}

	getAfiliados = (page, limit) => {
		let {
			searchtext,
			surname,
			name,
			documentNumber,
			cuil,
			status,
			rol
		} = this.props;
		if (rol === ROL_ADMIN || rol === ROL_SUB_ADMIN) {
			this.props.actionGetAfiliadosList(
				searchtext,
				surname,
				name,
				documentNumber,
				cuil,
				status,
				page,
				limit
			);
		} else if (
			(searchtext === "" || searchtext === " " || _.isEmpty(searchtext)) &&
			!surname &&
			!name &&
			!documentNumber &&
			!cuil &&
			!status
		)
			Util.showNoty(WARNING, "Ingrese algún criterio de búsqueda.");
		else {
			this.props.actionGetAfiliadosList(
				searchtext,
				surname,
				name,
				documentNumber,
				cuil,
				status,
				page,
				limit
			);
		}
	};

	renderPaginator = () => {
		return (
			<Paginator
				page={this.props.page}
				pageLimit={limitePagina}
				total={this.props.total}
				onChangePage={this.onChangePage}
			/>
		);
	};

	onChangeSearch = ({ target: { value } }) => {
		this.props.actionChangeAfiliadoProps({ searchtext: value });
	};

	onChangeSurname = ({ target: { value } }) => {
		this.props.actionChangeAfiliadoProps({ surname: value });
	};

	onChangeName = ({ target: { value } }) => {
		this.props.actionChangeAfiliadoProps({ name: value });
	};

	onChangeDocumentNumber = ({ target: { value } }) => {
		this.props.actionChangeAfiliadoProps({ documentNumber: value });
	};

	onChangeCuil = ({ target: { value } }) => {
		this.props.actionChangeAfiliadoProps({
			cuil: Util.formatCuitToNumber(value)
		});
	};

	onChangeStatus = (event, index, value) => {
		this.props.actionChangeAfiliadoProps({ status: value });
	};

	handleKeyPressSearchInput = e => {
		if (e.key === "Enter") this.handleSearch();
		else onKeyPressNumberOnly(e);
	};

	handleSearch = () => {
		this.props.actionChangeAfiliadoProps({
			page: 1,
			activeFilters: true
		});
		let cuil = this.props.cuil;
		if (cuil) {
			this.asynValidate(cuil);
		}
		this.getAfiliados(1, limitePagina);
	};

	cleanFilters = () => {
		this.props.actionChangeAfiliadoProps({
			searchtext: "",
			surname: "",
			name: "",
			documentNumber: "",
			cuil: "",
			status: "",
			activeFilters: false,
			afiliadosList: []
		});
	};

	onCreateOrUpdate(afiliado) {
		if (afiliado) {
			this.props.actionChangeAfiliadoProps({
				afiliado: afiliado,
				modeCRU: MODE_CRU_UPDATE,
				searchtext: ""
			});
			this.props.history.push(AFILIADOS_EDIT);
		} else {
			this.props.actionChangeAfiliadoProps({
				afiliado: null,
				modeCRU: MODE_CRU_CREATE,
				searchtext: ""
			});
			this.props.history.push(AFILIADOS_NEW);
		}
	}

	handleDelete(afiliado) {
		AppMem.confirmDialog.open({
			title: "Eliminar Afiliado",
			messageConfirm:
				"¿Esta seguro que desea eliminar afiliado" + afiliado.name + "?",
			onAccept: this.onTapConfirmDelete.bind(this, afiliado._id)
		});
	}

	handleShow(afiliado) {
		this.props.actionChangeAfiliadoProps({
			modeCRU: MODE_CRU_SHOW,
			afiliado: afiliado
		});
		this.props.history.push(AFILIADOS_EDIT);
	}

	onTapConfirmDelete(afiliadoId) {
		this.props.actionDeleteAfiliado(
			afiliadoId,
			this.returnConfirmDelete.bind(this)
		);
	}
	onGenerateExcel(type) {
		this.props.actionGenerateExcel(type, null, null, this.returnDownload);
	}
	returnDownload(type, blob) {
		let fechaActual = moment().format("DD-MM-YYYY");
		let nombreArchivo = "";
		if (type === "affiliate") nombreArchivo = "Afiliados - " + fechaActual;
		else nombreArchivo = "No Afiliados - " + fechaActual;
		download(blob, nombreArchivo);
	}

	returnConfirmDelete(response) {
		if (response === SUCCESS) {
			this.getAfiliados(this.props.page, limitePagina);
			Util.showNoty(response, "Afiliado eliminada exitosamente");
		} else if (response === ERROR) {
			Util.showNoty(response, "Error al eliminar afiliado");
		} else {
			Util.showNoty(
				response,
				"No se puede eliminar afiliado, tiene elementos asociados"
			);
		}
	}

	renderBlank = () => {
		let mensaje = "";
		if (this.props.busquedaRealizada) {
			mensaje = "No se encontraron resultados";
		} else {
			mensaje = "Aplique un criterio de búsqueda para visualizar datos";
		}
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>{mensaje}</p>
				</TableRowColumn>
			</TableRow>
		);
	};

	onChangePage = page => {
		this.props.actionChangeAfiliadoProps({
			page: page
		});
		this.getAfiliados(page, limitePagina);
	};

	callbackProcessExcel(response) {
		if (response === SUCCESS) {
			Util.showNoty(SUCCESS, "Afiliados importados correctamente");
			this.getAfiliados(this.props.page, limitePagina);
		}
	}

	renderBodyRows = afiliadosList => {
		const edit = this.onCreateOrUpdate;
		const show = this.handleShow;
		return _.map(afiliadosList, (afiliado, i) => {
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{afiliado.affiliateNumber}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{afiliado.person.surname}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{afiliado.person.name}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{afiliado.person.cuil}
					</TableRowColumn>
					<TableRowColumn
						style={
							afiliado.status === AFILIADO_INACTIVO
								? {
										marginLeft: 20,
										color: "red"
								  }
								: afiliado.status === AFILIADO_ACTIVO
									? {
											marginLeft: 20,
											color: "green"
									  }
									: { marginLeft: 20 }
						}
					>
						{afiliado.status}
					</TableRowColumn>
					<TableRowColumn>
						{this.props.rol === ROL_OPERADOR_RECAUDA ? (
							<OptionsTableRowColumn
								handleShow={() => show(afiliado)}
								showTooltip="Mostrar"
							/>
						) : (
							<OptionsTableRowColumn
								handleEdit={() => edit(afiliado)}
								showTooltip="Editar"
							/>
						)}
					</TableRowColumn>
				</TableRow>
			);
		});
	};
	renderFilterCardAdmin() {
		return (
			<FilterCard
				onChangeSearchField={this.onChangeSearch}
				InputValue={this.props.searchtext}
				onKeyPressSearchField={this.handleKeyPressSearchInput}
				onTouchTapSearch={() => this.handleSearch(this.props.searchtext)}
				labelSearchInput={"Buscar por Nro. Afiliado"}
				onTouchTapNew={() => this.onCreateOrUpdate()}
				onToggledFilter={() =>
					this.setState({ showFilterCard: !this.state.showFilterCard })
				}
				activeFilters={this.props.activeFilters}
				onTouchGenerateExcel={() => this.onGenerateExcel("affiliate")}
				generateExcelLabel={"Generar Excel de Afiliados"}
				onTouchGenerateExcelDDJJConcepts={() =>
					this.onGenerateExcel("affiliateNot")
				}
				generateExcelLabelDDJJConcepts={"Generar excel de NO Afiliados"}
			>
				<input
					type="file"
					onChange={e => this.setState({ affiliateFile: e.target.files[0] })}
					accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				/>
				<RaisedButton
					label="Importar afiliados"
					style={{ margin: 5 }}
					disabled={!this.state.affiliateFile}
					primary
					onClick={() =>
						this.props.actionProcessExcel(
							this.state.affiliateFile,
							this.callbackProcessExcel.bind(this)
						)
					}
				/>
			</FilterCard>
		);
	}
	renderFilterCardNoAdmin() {
		return (
			<FilterCard
				onChangeSearchField={this.onChangeSearch}
				InputValue={this.props.searchtext}
				onKeyPressSearchField={this.handleKeyPressSearchInput}
				onTouchTapSearch={() => this.handleSearch(this.props.searchtext)}
				labelSearchInput={"Buscar por Nro. Afiliado"}
				onTouchTapNew={() => this.onCreateOrUpdate()}
				onToggledFilter={() =>
					this.setState({ showFilterCard: !this.state.showFilterCard })
				}
				activeFilters={this.props.activeFilters}
			/>
		);
	}

	asynValidate(cuil) {
		return asyncCheckCuil(cuil).then(response => {
			if (response !== null) {
				if (_.size(response) >= 1 && !response.affiliateNumber) {
					AppMem.infoDialog.open({
						title: "CUIL declarado como No Afiliado",
						messageConfirm: `El CUIL ${cuil} ${response[0].surname} ${
							response[0].name
						} fue declarado como No Afiliado, Empresa: ${
							response[0].companyName
						} CUIT: ${response[0].cuit} Periodo: ${response[0].month}/${
							response[0].year
						}`,
						onAccept: () => ""
					});
				}
			}
		});
	}
	render() {
		return (
			<div className="center">
				<Card className="card">
					<CardTitle title="Afiliados" subtitle="Nómina de afiliados" />
					<CardText>
						{this.props.rol === ROL_ADMIN
							? this.renderFilterCardAdmin()
							: this.renderFilterCardNoAdmin()}
						<ReactCSSTransitionGroup
							transitionName="animate"
							transitionAppear={true}
							transitionAppearTimeout={5000}
							transitionEnter={true}
							transitionEnterTimeout={500}
							transitionLeaveTimeout={500}
							transitionLeave={true}
						>
							{!this.state.showFilterCard ? null : (
								<CardMedia>
									<div className="card-filter">
										<div className="centerBlock-filter">
											<TextField
												floatingLabelText="Apellido"
												value={this.props.surname}
												onChange={this.onChangeSurname}
												className="left10"
											/>
											<TextField
												floatingLabelText="Nombre"
												value={this.props.name}
												onChange={this.onChangeName}
												className="left10"
											/>
											<MaskedTextField
												floatingLabelText="DNI"
												value={this.props.documentNumber}
												onChange={this.onChangeDocumentNumber}
												style={{ width: 100 }}
												className="left10"
												mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
											/>
											<MaskedTextField
												floatingLabelText="CUIL"
												value={this.props.cuil}
												onChange={this.onChangeCuil}
												style={{ width: 120 }}
												className="left10"
												mask={[
													/\d/,
													/\d/,
													"-",
													/\d/,
													/\d/,
													/\d/,
													/\d/,
													/\d/,
													/\d/,
													/\d/,
													/\d/,
													"-",
													/\d/
												]}
											/>
											<SelectField
												floatingLabelText="Estado"
												value={this.props.status}
												onChange={this.onChangeStatus}
												className="left10"
											>
												<MenuItem
													key={1}
													value={PERSONA_IMPORTADO}
													primaryText={PERSONA_IMPORTADO}
												/>
												<MenuItem
													key={2}
													value={PERSONA_VERIFICADO}
													primaryText={PERSONA_VERIFICADO}
												/>
												<MenuItem
													key={3}
													value={PERSONA_VERIFICAR}
													primaryText={PERSONA_VERIFICAR}
												/>
											</SelectField>
										</div>
										<div style={{ textAlign: "center", padding: 10 }}>
											<FlatButton
												label="Quitar Filtros"
												onClick={this.cleanFilters}
											/>
											<RaisedButton
												label="Aplicar Filtros"
												primary={true}
												onClick={this.handleSearch}
											/>
										</div>
									</div>
								</CardMedia>
							)}
						</ReactCSSTransitionGroup>
						<Table selectable={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn>Nro. Afiliado</TableHeaderColumn>
									<TableHeaderColumn>Apellidos</TableHeaderColumn>
									<TableHeaderColumn>Nombres</TableHeaderColumn>
									<TableHeaderColumn>CUIL</TableHeaderColumn>
									<TableHeaderColumn>Estado</TableHeaderColumn>
									<TableHeaderColumn>Acciones</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.afiliadosList)
									? this.renderBodyRows(this.props.afiliadosList)
									: this.renderBlank()}
							</TableBody>
						</Table>
					</CardText>
					{!_.isEmpty(this.props.afiliadosList) ? this.renderPaginator() : ""}
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		searchtext: store.afiliado.searchtext,
		surname: store.afiliado.surname,
		name: store.afiliado.name,
		documentNumber: store.afiliado.documentNumber,
		cuil: store.afiliado.cuil,
		status: store.afiliado.status,
		afiliadosList: store.afiliado.afiliadosList,
		busquedaRealizada: store.afiliado.busquedaRealizada,
		activeFilters: store.afiliado.activeFilters,
		modeCRU: store.afiliado.modeCRU,
		page: store.afiliado.page,
		rol: store.app.rol,
		total: store.afiliado.total
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionDeleteAfiliado,
			actionChangeAfiliadoProps,
			actionGetAfiliadosList,
			actionGenerateExcel,
			actionProcessExcel,
			asyncCheckCuil
		},
		dispatch
	);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AfiliadosIndex);



// WEBPACK FOOTER //
// ./src/screens/Afiliado/AfiliadoIndex.js